import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponseCerner } from './transform';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton,
} from 'one-model-local';

import {
    setAction as billAction,
    reinitAction
} from 'one-state-pendingbills-cerner/src/actions';

import {
    RESET,
    SET as patientSET,
    SETSELECTED_CERNER
} from 'one-state-subject/src/types';

export const enum Types {
    SETBILLING = 'one-state-billing-details/set-cerner',
}

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);

/**
 * This Function will fetch the data of pending bills
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
// export const fetchPendingBills = (context: any) => (
//     (action$: any) => {
//         const errorTime = format(new Date(),'LT');
//         const errorDate = format(new Date(),'LL');
//         const { server, settings: { epicendpoints: { pendingbills, apitoken } } } = context;
//         return action$.pipe(
//             ofType(SETSELECTED),
//            
//             mergeMap((action: any) => {
//                 /**
//                  * @param dataresponse contains the data response
//                  */
//                 let dataresponse = action.payload;
//                 const getRequest = (payload: any) => {
//                     if (payload?.id) {


//                         let headers = new Headers();
//                         headers.set('Authorization', 'Basic ' + apitoken?.token);

//                         const response = server.get({
//                             path: pendingbills + "?PatientID=" + (payload.id ? payload.id : "") + "",
//                             headers: headers
//                         })
//                             .then((patientresponse: any) => patientresponse[0])
//                             .catch((responseerror: any) => {
//                                 let errorbuild: ErrorObject = {
//                                     source: "PendingBills",
//                                     type: "error",
//                                     status: responseerror?.status,
//                                     erroritems: responseerror?.errors,
//                                     error_date: errorDate,
//                                     error_time: errorTime
//                                 };
//                                 return errorbuild;
//                             })
//                         return from(response)
//                     } else {
//                         return from([]);
//                     }
//                 }
//                 //Calling getRequst function here
//                 //the reason is we need to use pipe function.
//                 return getRequest(dataresponse).
//                     pipe(
//                         map((response: any) => TransformResponse(response, context))).
//                     pipe(
//                         flatMap(billsresponse => {
//                             const actions: any = [
//                                 billAction(billsresponse.bills)];
//                             if (billsresponse.error) {
//                                 actions.push(addAction(billsresponse.error));
//                             }
//                             // clear skeleton for pending bills
//                             let skeletonpendingbills: Skeleton = {
//                                 pendingBills_skeleton: false
//                             }
//                             actions.push(pushToSkeleton(skeletonpendingbills));
//                             return actions;
//                         })
//                         // map((response:any) => billAction(response))
//                     )
//             })
//         )
//     }
// );

/**
 * This Function is used to Push pending bills to state
 * @param context contains settings json etc ..
 */
export const pushPendingBillsToStateCerner = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETBILLING),
            mergeMap((action: any) => {
                /**
                 * @param dataresposne contains the patientlookup response
                 */
                let dataresponse = action.payload;
                log.debug("one-epics/cerner-epics", "push Pending Bills to state request", dataresponse);
                if (dataresponse) {
                    const getRequest = (datares: any) => {
                        let result = TransformResponseCerner(datares, context);
                        log.debug("one-epics/cerner-epics", "push Pending Bills to state response", result);
                        return from([result]);
                    }
                    return getRequest(dataresponse).
                        pipe(
                            flatMap(billsresponse => {
                                const actions: any = [
                                    billAction(billsresponse.bills)
                                ];

                                // clear skeleton for pending bills
                                let skeletonpendingbills: Skeleton = {
                                    pendingBills_skeleton: false
                                }
                                actions.push(pushToSkeleton(skeletonpendingbills));
                                return actions;
                            })
                        )
                }
                else {
                    return from([]);
                }
            })

        )
    }
);

/**
 * This Fuction will clear data of pending bills epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearPendingBillsCerner= (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,pendingbills-cerner",
            "Reset-PendingBills-cerner", {
        });
        return action$.pipe(
            ofType(patientSET, RESET,SETSELECTED_CERNER),
            map(action => reinitAction()),
        )
    }
);